import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { BadgeDollarSign } from 'lucide-react';
import { FleetAuthoritySettings } from './FleetAuthoritySettings';

export const Route = createFileRoute('/console/$orgId/configuration/fleet/delegated-authority')({
    staticData: {
        // The fleet module is the per-tenant switch for this page (CUR-1052):
        // an organisation that does not run fleet never sees it.
        metadata: {
            title: 'Delegated authority',
        },
        ui: {
            icon: BadgeDollarSign,
            title: 'Delegated authority',
            subtitle:
                "The default repair authority for fleet clients, ex GST. Repairer quotes at or under it are approved automatically; anything above goes to the client's fleet manager. A client with its own limit on its record ignores this default.",
            menuDescription: 'Set the default delegated repair authority for fleet clients',
        },
        modules: ['fleet'],
        permissions: ['settings:update'],
    },
    component: ConfigurationFleetAuthority,
});

function ConfigurationFleetAuthority() {
    return (
        <PageController route={Route}>
            <FleetAuthoritySettings />
        </PageController>
    );
}
